import Transition, { ENTERED, ENTERING, EXITED, EXITING } from 'react-transition-group/Transition';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import { ThemeContext } from '@hig/theme-context';
import { createCustomClassNames, combineEventHandlers } from '@hig/utils';

var anchorPoints = Object.freeze({
  TOP_LEFT: "top-left",
  TOP_CENTER: "top-center",
  TOP_RIGHT: "top-right",
  RIGHT_TOP: "right-top",
  RIGHT_CENTER: "right-center",
  RIGHT_BOTTOM: "right-bottom",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_CENTER: "bottom-center",
  BOTTOM_RIGHT: "bottom-right",
  LEFT_TOP: "left-top",
  LEFT_CENTER: "left-center",
  LEFT_BOTTOM: "left-bottom"
});

var AVAILABLE_ANCHOR_POINTS = Object.freeze(Object.values(anchorPoints));

var HIDDEN = "hidden";

var transitionStatuses = Object.freeze({
  ENTERED: ENTERED,
  ENTERING: ENTERING,
  EXITED: EXITED,
  EXITING: EXITING,
  HIDDEN: HIDDEN
});

var AVAILABLE_TRANSITION_STATUSES = Object.freeze(Object.values(transitionStatuses));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TRANSITION_DURATION = 300;

var ContainerTransition = function (_Component) {
  _inherits(ContainerTransition, _Component);

  function ContainerTransition() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContainerTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContainerTransition.__proto__ || Object.getPrototypeOf(ContainerTransition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      in: _this.props.open,
      isVisible: _this.props.open
    }, _this.handleExit = function () {
      _this.hide();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContainerTransition, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.show();
      } else if (prevProps.open && !this.props.open) {
        this.beginExit();
      }
    }

    /**
     * @param {string} transitionState
     * @returns {string}
     */

  }, {
    key: "getTransitionStatus",
    value: function getTransitionStatus(transitionState) {
      return !this.state.isVisible ? transitionStatuses.HIDDEN : transitionState;
    }
  }, {
    key: "beginExit",
    value: function beginExit() {
      var _this2 = this;

      window.requestAnimationFrame(function () {
        _this2.setState({ in: false });
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;

      window.requestAnimationFrame(function () {
        _this3.setState({ isVisible: true }, function () {
          window.requestAnimationFrame(function () {
            _this3.setState({ in: true });
          });
        });
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this4 = this;

      window.requestAnimationFrame(function () {
        _this4.setState({ isVisible: false });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return React.createElement(
        Transition,
        {
          "in": this.state.in,
          onExited: this.handleExit,
          timeout: TRANSITION_DURATION
        },
        function (transitionState) {
          return _this5.props.children(_this5.getTransitionStatus(transitionState));
        }
      );
    }
  }]);

  return ContainerTransition;
}(Component);

ContainerTransition.propTypes = {
  children: PropTypes.func.isRequired,
  open: PropTypes.bool
};
ContainerTransition.defaultProps = {
  open: false
};
ContainerTransition.__docgenInfo = {
  "description": "",
  "displayName": "ContainerTransition",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    }
  }
};

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * @typedef {Object} Payload
 * @property {string} anchorPoint
 * @property {DOMRect} actionRect
 * @property {DOMRect} panelRect
 * @property {DOMRect} pointerRect
 * @property {DOMRect} viewportRect
 */

/**
 * @typedef {Object} Position
 * @property {number} top
 * @property {number} left
 */

/**
 * @typedef {Object} Coordinates
 * @property {string} anchorPoint
 * @property {Position} containerPosition
 * @property {Position} pointerPosition
 */

var ACTION_OVERLAP = 0;
var POINTER_OVERLAP = 1;
var TOP_LEFT = anchorPoints.TOP_LEFT,
    TOP_CENTER = anchorPoints.TOP_CENTER,
    TOP_RIGHT = anchorPoints.TOP_RIGHT,
    RIGHT_TOP = anchorPoints.RIGHT_TOP,
    RIGHT_CENTER = anchorPoints.RIGHT_CENTER,
    RIGHT_BOTTOM = anchorPoints.RIGHT_BOTTOM,
    BOTTOM_LEFT = anchorPoints.BOTTOM_LEFT,
    BOTTOM_CENTER = anchorPoints.BOTTOM_CENTER,
    BOTTOM_RIGHT = anchorPoints.BOTTOM_RIGHT,
    LEFT_TOP = anchorPoints.LEFT_TOP,
    LEFT_CENTER = anchorPoints.LEFT_CENTER,
    LEFT_BOTTOM = anchorPoints.LEFT_BOTTOM;

/**
 * @type {Position}
 */

var DEFAULT_POSITION = Object.freeze({
  top: 0,
  left: 0
});

/**
 * @type {Coordinates}
 */
var DEFAULT_COORDINATES = Object.freeze({
  anchorPoint: anchorPoints.TOP_LEFT,
  containerPosition: DEFAULT_POSITION,
  pointerPosition: DEFAULT_POSITION
});

/**
 * @param {Payload} payload
 * @returns {number}
 */
function calculatePointerTopOffset(_ref) {
  var anchorPoint = _ref.anchorPoint,
      actionRect = _ref.actionRect,
      panelRect = _ref.panelRect,
      pointerRect = _ref.pointerRect;

  switch (anchorPoint) {
    case TOP_CENTER:
    case TOP_LEFT:
    case TOP_RIGHT:
      return -1 * (pointerRect.height - (pointerRect.height / 2 + POINTER_OVERLAP));
    case BOTTOM_CENTER:
    case BOTTOM_LEFT:
    case BOTTOM_RIGHT:
      return panelRect.height - (pointerRect.height / 2 + POINTER_OVERLAP);
    case LEFT_BOTTOM:
    case RIGHT_BOTTOM:
      return panelRect.height - actionRect.height / 2 - pointerRect.height / 2;
    case LEFT_CENTER:
    case RIGHT_CENTER:
      return panelRect.height / 2 - pointerRect.height / 2;
    case LEFT_TOP:
    case RIGHT_TOP:
      return actionRect.height / 2 - pointerRect.height / 2;
    default:
      return DEFAULT_COORDINATES.pointerPosition.top;
  }
}

/**
 * @param {Payload} payload
 * @returns {number}
 */
function calculatePointerLeftOffset(_ref2) {
  var anchorPoint = _ref2.anchorPoint,
      actionRect = _ref2.actionRect,
      panelRect = _ref2.panelRect,
      pointerRect = _ref2.pointerRect;

  switch (anchorPoint) {
    case LEFT_BOTTOM:
    case LEFT_CENTER:
    case LEFT_TOP:
      return -1 * (pointerRect.width - (pointerRect.width / 2 + POINTER_OVERLAP));
    case RIGHT_BOTTOM:
    case RIGHT_CENTER:
    case RIGHT_TOP:
      return panelRect.width - (pointerRect.width / 2 + POINTER_OVERLAP);
    case TOP_CENTER:
    case BOTTOM_CENTER:
      return panelRect.width / 2 - pointerRect.width / 2;
    case TOP_LEFT:
    case BOTTOM_LEFT:
      return actionRect.width / 2 - pointerRect.width / 2;
    case TOP_RIGHT:
    case BOTTOM_RIGHT:
      return panelRect.width - (actionRect.width / 2 + pointerRect.width / 2);
    default:
      return DEFAULT_COORDINATES.pointerPosition.left;
  }
}

/**
 * @param {Payload} payload
 * @returns {number}
 */
function calculatePanelContainerTopOffset(_ref3) {
  var anchorPoint = _ref3.anchorPoint,
      actionRect = _ref3.actionRect,
      panelRect = _ref3.panelRect,
      pointerRect = _ref3.pointerRect;

  switch (anchorPoint) {
    case TOP_LEFT:
    case TOP_CENTER:
    case TOP_RIGHT:
      return actionRect.height + pointerRect.height / 2 - ACTION_OVERLAP;
    case BOTTOM_LEFT:
    case BOTTOM_CENTER:
    case BOTTOM_RIGHT:
      return -1 * panelRect.height - pointerRect.height / 2 + ACTION_OVERLAP;
    case LEFT_TOP:
    case RIGHT_TOP:
      return 0;
    case LEFT_CENTER:
    case RIGHT_CENTER:
      return (panelRect.height - actionRect.height) / -2;
    case LEFT_BOTTOM:
    case RIGHT_BOTTOM:
      return -1 * (panelRect.height - actionRect.height);
    default:
      return DEFAULT_COORDINATES.containerPosition.top;
  }
}

/**
 * @param {Payload} payload
 * @returns {number}
 */
function calculatePanelContainerLeftOffset(_ref4) {
  var anchorPoint = _ref4.anchorPoint,
      actionRect = _ref4.actionRect,
      panelRect = _ref4.panelRect,
      pointerRect = _ref4.pointerRect;

  switch (anchorPoint) {
    case LEFT_TOP:
    case LEFT_CENTER:
    case LEFT_BOTTOM:
      return actionRect.width + pointerRect.width / 2 - ACTION_OVERLAP;
    case RIGHT_TOP:
    case RIGHT_CENTER:
    case RIGHT_BOTTOM:
      return -1 * panelRect.width - pointerRect.width / 2 + ACTION_OVERLAP;
    case TOP_LEFT:
    case BOTTOM_LEFT:
      return 0;
    case TOP_CENTER:
    case BOTTOM_CENTER:
      return -1 * ((panelRect.width - actionRect.width) / 2);
    case TOP_RIGHT:
    case BOTTOM_RIGHT:
      return -1 * (panelRect.width - actionRect.width);
    default:
      return DEFAULT_COORDINATES.containerPosition.top;
  }
}

/**
 * @param {Payload} payload
 * @returns {Coordinates}
 */
function calculatePointerPosition(props) {
  return {
    top: calculatePointerTopOffset(props),
    left: calculatePointerLeftOffset(props)
  };
}

/**
 * @param {Payload} payload
 * @returns {Coordinates}
 */
function calculatePanelContainerPosition(props) {
  return {
    top: calculatePanelContainerTopOffset(props),
    left: calculatePanelContainerLeftOffset(props)
  };
}

/**
 * @param {Payload} payload
 * @returns {Coordinates}
 */
function calculateCoordinates(props) {
  return {
    anchorPoint: props.anchorPoint,
    containerPosition: calculatePanelContainerPosition(props),
    pointerPosition: calculatePointerPosition(props)
  };
}

/**
 * Determines whether the given position is entirely within the viewport
 * @param {Payload} payload
 * @returns {function(Coordinates): boolean}
 */
function createViewportDeterminer(props) {
  var viewportRect = props.viewportRect,
      panelRect = props.panelRect,
      actionRect = props.actionRect;


  return function isInViewport(_ref5) {
    var containerPosition = _ref5.containerPosition;

    var containerTop = actionRect.top + containerPosition.top;
    var containerLeft = actionRect.left + containerPosition.left;
    var containerRight = containerLeft + panelRect.width;
    var containerBottom = containerTop + panelRect.height;
    var result = containerLeft >= viewportRect.left && containerTop >= viewportRect.top && containerRight <= viewportRect.right && containerBottom <= viewportRect.bottom;

    return result;
  };
}

/**
 * @param {payload} GetFlyoutPositionPayload
 * @returns {FlyoutPosition}
 */
function getFallbackCoordinates(payload) {
  var isInViewport = createViewportDeterminer(payload);

  return payload.fallbackAnchorPoints.map(function (anchorPoint) {
    return calculateCoordinates(_extends({}, payload, { anchorPoint: anchorPoint }));
  }).find(isInViewport);
}

/**
 * @param {Payload} payload
 * @returns {Coordinates}
 */
function getCoordinates(payload) {
  var coordinates = calculateCoordinates(payload);
  var isInViewport = createViewportDeterminer(payload);

  if (isInViewport(coordinates)) {
    return coordinates;
  }

  var fallbackCoordinates = getFallbackCoordinates(payload);

  return fallbackCoordinates || coordinates;
}

function getStyle(themeData, role) {
  return themeData[role];
}

function getAnchorPointTransformTranslate(anchorPoint) {
  switch (anchorPoint) {
    case "top-left":
    case "top-center":
    case "top-right":
      return "translateY(-4px)";
    case "right-top":
    case "right-center":
    case "right-bottom":
      return "translateX(4px)";
    case "bottom-left":
    case "bottom-center":
    case "bottom-right":
      return "translateY(4px)";
    case "left-top":
    case "left-center":
    case "left-bottom":
      return "translateX(-4px)";
    default:
      return "none";
  }
}

function getAnchorPointTransformRotate(anchorPoint) {
  switch (anchorPoint) {
    case "right-top":
    case "right-center":
    case "right-bottom":
      return "rotate(90deg)";
    case "bottom-left":
    case "bottom-center":
    case "bottom-right":
      return "rotate(180deg)";
    case "left-top":
    case "left-center":
    case "left-bottom":
      return "rotate(-90deg)";
    default:
      return "rotate(0deg)";
  }
}

function stylesheet (props, themeData) {
  var transitionStatus = props.transitionStatus,
      anchorPoint = props.anchorPoint,
      stylesheet = props.stylesheet;

  var isExiting = transitionStatus === "exiting";
  var isExited = transitionStatus === "exited";
  var isHidden = transitionStatus === "hidden";
  var backgroundColor = themeData ? getStyle(themeData, "flyout.backgroundColor") : "transparent";
  var borderColor = themeData ? getStyle(themeData, "flyout.borderColor") : "none";
  var borderRadius = themeData ? getStyle(themeData, "flyout.borderRadius") : "none";
  var shadowBlur = themeData ? getStyle(themeData, "flyout.shadowBlur") : 0;
  var shadowColor = themeData ? getStyle(themeData, "flyout.shadowColor") : "transparent";
  var densitySmall = themeData ? getStyle(themeData, "density.spacings.small") : 0;

  var styles = {
    flyoutWrapper: {
      position: "relative",
      display: "inline-block"
    },
    flyoutAction: {
      display: "flex"
    },
    flyoutContainer: {
      position: "absolute",
      // Resolves issues with negative positions and container overflow
      display: isHidden ? "none" : "table",
      width: "100%",
      zIndex: 9999,
      transitionProperty: "opacity, transform",
      transitionDuration: "250ms",
      // Bounce effect
      transitionTimingFunction: "cubic-bezier(0.77, 0, 0.265, 2)",
      touchAction: isExiting || isExited ? "none" : "auto",
      pointerEvents: isExiting || isExited ? "none" : "auto",
      opacity: isExiting || isExited ? 0 : 1,
      transform: isExiting || isExited ? getAnchorPointTransformTranslate(anchorPoint) : "none"
    },
    panelContainer: {
      backgroundColor: backgroundColor,
      borderRadius: borderRadius,
      border: "none",
      boxShadow: "0 0 " + shadowBlur + " " + shadowColor
    },
    panelContainerInner: {
      position: "relative"
    },
    panel: {
      minWidth: "200px",
      maxHeight: "360px",
      padding: densitySmall,
      overflowY: "auto",
      msOverflowStyle: "-ms-autohiding-scrollbar"
    },
    pointerWrapper: {
      display: "flex",
      position: "absolute",
      transform: getAnchorPointTransformRotate(anchorPoint)
    },
    pointerBorder: {
      fill: borderColor
    },
    pointerBody: {
      fill: backgroundColor
    }
  };

  if (stylesheet) {
    return stylesheet(styles, props, themeData);
  }

  return styles;
}

function PointerPresenter(props) {
  var borderWidth = props.borderWidth,
      size = props.size;

  var height = size / 2;
  var width = size;
  var widthMidpoint = width / 2;

  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref) {
      var resolvedRoles = _ref.resolvedRoles;

      var styles = stylesheet(props, resolvedRoles);

      return React.createElement(
        "svg",
        {
          height: size.toString(),
          viewBox: "0 0 " + size + " " + size,
          width: width.toString()
        },
        React.createElement("polygon", {
          className: css(styles.pointerBorder),
          points: ["0," + height, widthMidpoint + ",0", width + "," + height].join(" ")
        }),
        React.createElement("polygon", {
          className: css(styles.pointerBody),
          points: [borderWidth + "," + height, widthMidpoint + "," + borderWidth, width - borderWidth + "," + height].join(" ")
        })
      );
    }
  );
}

PointerPresenter.defaultProps = {
  borderWidth: 2.5,
  size: 24
};

PointerPresenter.propTypes = {
  borderWidth: PropTypes.number,
  size: PropTypes.number
};
PointerPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PointerPresenter",
  "props": {
    "borderWidth": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "2.5",
        "computed": false
      }
    },
    "size": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "24",
        "computed": false
      }
    }
  }
};

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function PointerWrapperPresenter(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef,
      style = _ref.style,
      anchorPoint = _ref.anchorPoint,
      customStylesheet = _ref.stylesheet,
      otherProps = _objectWithoutProperties(_ref, ["children", "innerRef", "style", "anchorPoint", "stylesheet"]);

  var styles = stylesheet({
    transitionStatus: null,
    anchorPoint: anchorPoint,
    stylesheet: customStylesheet
  });
  var className = otherProps.className;

  var pointerWrapperClassName = createCustomClassNames(className, "pointer-wrapper");

  return React.createElement(
    "div",
    {
      "aria-hidden": "true",
      className: cx(css(styles.pointerWrapper), pointerWrapperClassName),
      ref: innerRef,
      role: "presentation",
      style: style
    },
    children
  );
}

PointerWrapperPresenter.propTypes = {
  children: PropTypes.node,
  innerRef: PropTypes.func,
  /* eslint-disable-next-line react/forbid-prop-types */
  style: PropTypes.object,
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS),
  stylesheet: PropTypes.func
};
PointerWrapperPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PointerWrapperPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "style": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @param {import("../getCoordinates").Position} position
 * @returns {import("react").CSSProperties}
 */
function positionToStyle(_ref) {
  var top = _ref.top,
      left = _ref.left;

  return {
    top: top + "px",
    left: left + "px"
  };
}

function FlyoutPresenter(props) {
  var anchorPoint = props.anchorPoint,
      containerPosition = props.containerPosition,
      children = props.children,
      panel = props.panel,
      pointer = props.pointer,
      pointerPosition = props.pointerPosition,
      refAction = props.refAction,
      refPointer = props.refPointer,
      refWrapper = props.refWrapper,
      transitionStatus = props.transitionStatus,
      customStylesheet = props.stylesheet,
      otherProps = _objectWithoutProperties$1(props, ["anchorPoint", "containerPosition", "children", "panel", "pointer", "pointerPosition", "refAction", "refPointer", "refWrapper", "transitionStatus", "stylesheet"]);

  var className = otherProps.className;

  var flyoutActionClassName = createCustomClassNames(className, "flyout-action");
  var flyoutContainerClassName = createCustomClassNames(className, "flyout-container");
  var containerStyle = positionToStyle(containerPosition);
  var pointerStyle = positionToStyle(pointerPosition);

  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref2) {
      var resolvedRoles = _ref2.resolvedRoles;

      var styles = stylesheet({ transitionStatus: transitionStatus, anchorPoint: anchorPoint, stylesheet: customStylesheet }, resolvedRoles);

      return React.createElement(
        "div",
        {
          className: cx(css(styles.flyoutWrapper), className),
          ref: refWrapper
        },
        React.createElement(
          "div",
          {
            className: cx(css(styles.flyoutAction), flyoutActionClassName),
            ref: refAction
          },
          children
        ),
        React.createElement(
          "div",
          {
            className: cx(css(styles.flyoutContainer), flyoutContainerClassName),
            style: containerStyle
          },
          React.createElement(
            PointerWrapperPresenter,
            {
              innerRef: refPointer,
              anchorPoint: anchorPoint,
              style: pointerStyle,
              className: className,
              stylesheet: customStylesheet
            },
            pointer || React.createElement(PointerPresenter, { stylesheet: customStylesheet })
          ),
          panel
        )
      );
    }
  );
}

FlyoutPresenter.defaultProps = {
  anchorPoint: DEFAULT_COORDINATES.anchorPoint,
  containerPosition: DEFAULT_COORDINATES.containerPosition,
  pointerPosition: DEFAULT_COORDINATES.pointerPosition,
  transitionStatus: transitionStatuses.EXITED
};

FlyoutPresenter.propTypes = {
  /** Where the flyout will be anchored relative to target */
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS),
  /** Content for the flyout */
  panel: PropTypes.node,
  /** Pointer for the flyout */
  pointer: PropTypes.node,
  /** Top/Left position of the container relative to the action */
  containerPosition: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),
  /** Top/Left position of the pointer relative to the action */
  pointerPosition: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),
  /** Reference the action element */
  refAction: PropTypes.func,
  /** Reference the pointer element */
  refPointer: PropTypes.func,
  /** Reference the wrapper element */
  refWrapper: PropTypes.func,
  /** The status of the container transition */
  transitionStatus: PropTypes.oneOf(AVAILABLE_TRANSITION_STATUSES),
  /** Target component to open the flyout */
  children: PropTypes.node,
  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
};
FlyoutPresenter.__docgenInfo = {
  "description": "",
  "displayName": "FlyoutPresenter",
  "props": {
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": "Where the flyout will be anchored relative to target",
      "defaultValue": {
        "value": "DEFAULT_COORDINATES.anchorPoint",
        "computed": true
      }
    },
    "panel": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Content for the flyout"
    },
    "pointer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Pointer for the flyout"
    },
    "containerPosition": {
      "type": {
        "name": "shape",
        "value": {
          "top": {
            "name": "number",
            "required": false
          },
          "left": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Top/Left position of the container relative to the action",
      "defaultValue": {
        "value": "DEFAULT_COORDINATES.containerPosition",
        "computed": true
      }
    },
    "pointerPosition": {
      "type": {
        "name": "shape",
        "value": {
          "top": {
            "name": "number",
            "required": false
          },
          "left": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Top/Left position of the pointer relative to the action",
      "defaultValue": {
        "value": "DEFAULT_COORDINATES.pointerPosition",
        "computed": true
      }
    },
    "refAction": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Reference the action element"
    },
    "refPointer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Reference the pointer element"
    },
    "refWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Reference the wrapper element"
    },
    "transitionStatus": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_TRANSITION_STATUSES"
      },
      "required": false,
      "description": "The status of the container transition",
      "defaultValue": {
        "value": "transitionStatuses.EXITED",
        "computed": true
      }
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Target component to open the flyout"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoverBehavior = function (_Component) {
  _inherits$1(HoverBehavior, _Component);

  function HoverBehavior(props) {
    _classCallCheck$1(this, HoverBehavior);

    // Binding in the constructor because performance
    var _this = _possibleConstructorReturn$1(this, (HoverBehavior.__proto__ || Object.getPrototypeOf(HoverBehavior)).call(this, props));

    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);

    _this.state = {
      hasHover: false
    };
    return _this;
  }

  _createClass$1(HoverBehavior, [{
    key: "handleFocus",
    value: function handleFocus(event) {
      var _this2 = this;

      var _props = this.props,
          openOnHoverDelay = _props.openOnHoverDelay,
          onMouseEnter = _props.onMouseEnter;


      if (onMouseEnter) {
        this.focusTimeout = setTimeout(function () {
          _this2.setState({ hasHover: true });
          onMouseEnter(event);
        }, openOnHoverDelay);
      }

      this.setState({ hasHover: true });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      clearTimeout(this.focusTimeout);
      this.setState({ hasHover: false });

      if (this.props.onMouseLeave) {
        this.props.onMouseLeave(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        hasHover: this.state.hasHover,
        onMouseEnter: this.handleFocus,
        onMouseLeave: this.handleBlur
      });
    }
  }]);

  return HoverBehavior;
}(Component);

HoverBehavior.propTypes = {
  /**
   * Generally the Flyout target and presenter
   */
  children: PropTypes.func.isRequired,
  /**
   * Amount of time between mouse enter is reported and when
   * onMouseEnter event should fire
   */
  openOnHoverDelay: PropTypes.number,
  /**
   * Function called when the user enters the visual space
   * occupied by the component
   */
  onMouseEnter: PropTypes.func,
  /**
   * Function called when the user leaves the visual space
   * occupied by the component
   */
  onMouseLeave: PropTypes.func
};
HoverBehavior.__docgenInfo = {
  "description": "",
  "displayName": "HoverBehavior",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Generally the Flyout target and presenter"
    },
    "openOnHoverDelay": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Amount of time between mouse enter is reported and when\nonMouseEnter event should fire"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the user enters the visual space\noccupied by the component"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the user leaves the visual space\noccupied by the component"
    }
  }
};

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function PanelContainerPresenter(props) {
  var children = props.children,
      innerRef = props.innerRef,
      maxHeight = props.maxHeight,
      customStylesheet = props.stylesheet,
      otherProps = _objectWithoutProperties$2(props, ["children", "innerRef", "maxHeight", "stylesheet"]);

  var className = otherProps.className;

  var maxHeightInPixels = maxHeight ? maxHeight + "px" : undefined;
  var panelContainerClassName = createCustomClassNames(className, "panel-container");
  var panelContainerInnerClassName = createCustomClassNames(className, "panel-container-inner");

  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref) {
      var resolvedRoles = _ref.resolvedRoles,
          metadata = _ref.metadata;

      var themeId = metadata.colorSchemeId;
      var styles = stylesheet({
        transitionStatus: null,
        anchorPoint: null,
        stylesheet: customStylesheet
      }, resolvedRoles, themeId);

      return React.createElement(
        "div",
        {
          className: cx(css(styles.panelContainer), panelContainerClassName),
          ref: innerRef,
          style: { maxHeight: maxHeightInPixels }
        },
        React.createElement(
          "div",
          {
            className: cx(css(styles.panelContainerInner), panelContainerInnerClassName)
          },
          children
        )
      );
    }
  );
}

PanelContainerPresenter.propTypes = {
  /** A required ref that's used to position the flyout */
  innerRef: PropTypes.func.isRequired,
  /** The panel content */
  children: PropTypes.node,
  /** Max height of the panel */
  maxHeight: PropTypes.number,
  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
};
PanelContainerPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PanelContainerPresenter",
  "props": {
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "A required ref that's used to position the flyout"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "The panel content"
    },
    "maxHeight": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Max height of the panel"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};

function _objectWithoutProperties$3(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function PanelPresenter(_ref) {
  var children = _ref.children,
      onScroll = _ref.onScroll,
      customStylesheet = _ref.stylesheet,
      otherProps = _objectWithoutProperties$3(_ref, ["children", "onScroll", "stylesheet"]);

  var className = otherProps.className;

  var panelClassName = createCustomClassNames(className, "panel");

  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref2) {
      var resolvedRoles = _ref2.resolvedRoles;

      var styles = stylesheet({
        transitionStatus: null,
        anchorPoint: null,
        stylesheet: customStylesheet
      }, resolvedRoles);

      return React.createElement(
        "div",
        {
          className: cx(css(styles.panel), panelClassName),
          onScroll: onScroll
        },
        children
      );
    }
  );
}

PanelPresenter.propTypes = {
  children: PropTypes.node,
  onScroll: PropTypes.func,
  stylesheet: PropTypes.func
};
PanelPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PanelPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "onScroll": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$4(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @typedef {import("./getCoordinates").Coordinates} Coordinates */

/**
 * @typedef {Object} PanelRendererPayload
 * @property {function(HTMLElement): void} innerRef
 * @property {function(): void} hideFlyout
 * @property {JSX} [content]
 * @property {function(UIEvent): void} [handleScroll]
 * @property {number} [maxHeight]
 */

/**
 * @typedef {Object} State
 * @property {HTMLElement} [actionRef]
 * @property {boolean} open Used to direct the flyout's transition behavior
 * @property {HTMLElement} [panelRef]
 * @property {SVGSVGElement} [pointerRef]
 * @property {HTMLDivElement} [wrapperRef]
 */

var Flyout = function (_Component) {
  _inherits$2(Flyout, _Component);

  function Flyout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$2(this, Flyout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$2(this, (_ref = Flyout.__proto__ || Object.getPrototypeOf(Flyout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: _this.props.defaultOpen
    }, _this.handleChildMouseEnter = function () {
      if (_this.props.openOnHover) {
        _this.setOpen(true);
      }
    }, _this.handleChildMouseLeave = function () {
      if (_this.props.openOnHover) {
        _this.setOpen(false);
      }
    }, _this.handleChildClick = function () {
      if (!_this.isOpenControlled()) {
        _this.toggleOpen();
      }
    }, _this.handleBodyClick = function (event) {
      var wrapperRef = _this.state.wrapperRef;
      var onClickOutside = _this.props.onClickOutside;

      var flyoutClicked = event.target === wrapperRef || wrapperRef.contains(event.target);

      if (flyoutClicked || !_this.isOpen()) return;
      if (onClickOutside) onClickOutside(event);
      if (!_this.isOpenControlled()) _this.toggleOpen();
    }, _this.refAction = function (actionRef) {
      _this.setState({ actionRef: actionRef });
    }, _this.refPointer = function (pointerRef) {
      _this.setState({ pointerRef: pointerRef });
    }, _this.refPanel = function (panelRef) {
      _this.setState({ panelRef: panelRef });
    }, _this.refWrapper = function (wrapperRef) {
      _this.setState({ wrapperRef: wrapperRef });
    }, _this.hideFlyout = function () {
      _this.setOpen(false);
    }, _this.renderPresenter = function (transitionStatus) {
      var _this2 = _this,
          handleChildMouseEnter = _this2.handleChildMouseEnter,
          handleChildMouseLeave = _this2.handleChildMouseLeave,
          refAction = _this2.refAction,
          refPointer = _this2.refPointer,
          refWrapper = _this2.refWrapper;

      var _this$props = _this.props,
          openOnHoverDelay = _this$props.openOnHoverDelay,
          pointer = _this$props.pointer,
          stylesheet = _this$props.stylesheet,
          otherProps = _objectWithoutProperties$4(_this$props, ["openOnHoverDelay", "pointer", "stylesheet"]);

      var className = otherProps.className;

      var panel = _this.renderPanel({ transitionStatus: transitionStatus });

      var _this$getCoordinates = _this.getCoordinates(),
          anchorPoint = _this$getCoordinates.anchorPoint,
          containerPosition = _this$getCoordinates.containerPosition,
          pointerPosition = _this$getCoordinates.pointerPosition;

      return React.createElement(
        HoverBehavior,
        {
          onMouseEnter: handleChildMouseEnter,
          onMouseLeave: handleChildMouseLeave,
          openOnHoverDelay: openOnHoverDelay
        },
        function (_ref2) {
          var onMouseEnter = _ref2.onMouseEnter,
              onMouseLeave = _ref2.onMouseLeave;
          return React.createElement(
            FlyoutPresenter,
            {
              anchorPoint: anchorPoint,
              className: className,
              stylesheet: stylesheet,
              containerPosition: containerPosition,
              panel: panel,
              pointer: pointer,
              pointerPosition: pointerPosition,
              refAction: refAction,
              refPointer: refPointer,
              refWrapper: refWrapper,
              transitionStatus: transitionStatus
            },
            _this.renderChildren(onMouseEnter, onMouseLeave)
          );
        }
      );
    }, _temp), _possibleConstructorReturn$2(_this, _ret);
  }

  /** @type {State} */


  _createClass$2(Flyout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.document.body.addEventListener("click", this.handleBodyClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.document.body.removeEventListener("click", this.handleBodyClick);
    }

    /**
     * @returns {Coordinates}
     */

  }, {
    key: "getCoordinates",
    value: function getCoordinates$$1() {
      var _props = this.props,
          alterCoordinates = _props.alterCoordinates,
          anchorPoint = _props.anchorPoint,
          fallbackAnchorPoints = _props.fallbackAnchorPoints;
      var _state = this.state,
          actionRef = _state.actionRef,
          panelRef = _state.panelRef,
          pointerRef = _state.pointerRef;


      if (!actionRef || !panelRef || !pointerRef || typeof window === "undefined") {
        return DEFAULT_COORDINATES;
      }

      var actionRect = actionRef.getBoundingClientRect();
      var panelRect = panelRef.getBoundingClientRect();
      var pointerRect = pointerRef.getBoundingClientRect();
      var viewportRect = window.document.documentElement.getBoundingClientRect();
      var coordinates = getCoordinates({
        anchorPoint: anchorPoint,
        actionRect: actionRect,
        fallbackAnchorPoints: fallbackAnchorPoints,
        panelRect: panelRect,
        pointerRect: pointerRect,
        viewportRect: viewportRect
      });

      if (alterCoordinates) {
        var rects = {
          actionRect: actionRect,
          panelRect: panelRect,
          pointerRect: pointerRect,
          viewportRect: viewportRect
        };

        return alterCoordinates(coordinates, rects);
      }

      return coordinates;
    }

    /**
     * @param {boolean} open
     */

  }, {
    key: "setOpen",
    value: function setOpen(open) {
      var _props2 = this.props,
          onClose = _props2.onClose,
          onOpen = _props2.onOpen;


      if (open && onOpen) {
        onOpen();
      } else if (!open && onClose) {
        onClose();
      }

      this.setState({ open: open });
    }
  }, {
    key: "isOpenControlled",
    value: function isOpenControlled() {
      return this.props.open !== undefined;
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.isOpenControlled() ? this.props.open : this.state.open;
    }

    /**
     * @param {MouseEvent} event
     */


    /**
     * @param {HTMLElement} actionRef
     */


    /**
     * @param {SVGSVGElement} pointerRef
     */


    /**
     * @param {HTMLElement} panelRef
     */


    /**
     * @param {HTMLDivElement} wrapperRef
     */

  }, {
    key: "toggleOpen",
    value: function toggleOpen() {
      this.setOpen(!this.state.open);
    }

    /**
     * @returns {PanelRendererPayload}
     */

  }, {
    key: "createPanelPayload",
    value: function createPanelPayload() {
      var hideFlyout = this.hideFlyout;

      var _props3 = this.props,
          maxHeight = _props3.maxHeight,
          onScroll = _props3.onScroll,
          stylesheet = _props3.stylesheet,
          otherProps = _objectWithoutProperties$4(_props3, ["maxHeight", "onScroll", "stylesheet"]);

      var className = otherProps.className;


      return {
        hideFlyout: hideFlyout,
        maxHeight: maxHeight,
        content: this.renderContent(),
        handleScroll: onScroll,
        innerRef: this.refPanel,
        className: className,
        stylesheet: stylesheet
      };
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var content = this.props.content;
      var hideFlyout = this.hideFlyout;


      if (typeof content === "function") {
        return content({ hideFlyout: hideFlyout });
      }

      return content;
    }
  }, {
    key: "renderPanel",
    value: function renderPanel(_ref3) {
      var transitionStatus = _ref3.transitionStatus;
      var panel = this.props.panel;


      if (typeof panel === "function") {
        return panel(_extends$1({}, this.createPanelPayload(), {
          transitionStatus: transitionStatus
        }));
      }

      return panel;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(onMouseEnter, onMouseLeave) {
      var children = this.props.children;
      var handleChildClick = this.handleChildClick;


      if (typeof children === "function") {
        return children({ handleClick: handleChildClick });
      }

      if (React.Children.count(children) === 1) {
        return React.cloneElement(children, {
          onClick: combineEventHandlers(handleChildClick, children.props.onClick),
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        });
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        ContainerTransition,
        { open: this.isOpen() },
        this.renderPresenter
      );
    }
  }]);

  return Flyout;
}(Component);

Flyout.propTypes = {
  /** Manipulate flyout coordinates before rendering */
  alterCoordinates: PropTypes.func,
  /** Where the flyout will be anchored relative to target */
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS),
  /** Target component to open the flyout. Can be either a node or a render function */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /** Content for the flyout. Can be either a node or a render function */
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /** Default uncontrolled open state */
  defaultOpen: PropTypes.bool,
  /**
   * When the flyout overflows the viewport, it'll attempt to
   * use the given anchor points in order to keep the flyout
   * within the viewport.
   */
  fallbackAnchorPoints: PropTypes.arrayOf(PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS)),
  /** Renders a custom flyout panel. Can be either a node or a render function */
  panel: PropTypes.func,
  /** A custom pointer */
  pointer: PropTypes.node,
  /** Max height of the flyout content, in pixels */
  maxHeight: PropTypes.number,
  /** Function called when the flyout is open, and a click event occurs outside the flyout */
  onClickOutside: PropTypes.func,
  /** Function called when the flyout closes */
  onClose: PropTypes.func,
  /** Function called when the flyout opens */
  onOpen: PropTypes.func,
  /** Function called when the flyout panel is scrolled */
  onScroll: PropTypes.func,
  /** When provided, it overrides the flyout's open state */
  open: PropTypes.bool,
  /** Whether flyout should open when the target is hovered over */
  openOnHover: PropTypes.bool,
  /**
   * If openOnHover is true, this prop will determine the delay
   * from when mouseEnter begins until the flyout visually opens
   */
  openOnHoverDelay: PropTypes.number,
  /** Function to modify the component's styles */
  stylesheet: PropTypes.func
};
Flyout.defaultProps = {
  anchorPoint: DEFAULT_COORDINATES.anchorPoint,
  defaultOpen: false,
  fallbackAnchorPoints: AVAILABLE_ANCHOR_POINTS,
  openOnHover: false,
  openOnHoverDelay: 500,
  /**
   * @param {PanelRendererPayload} payload
   */
  panel: function panel(_ref4) {
    var innerRef = _ref4.innerRef,
        content = _ref4.content,
        handleScroll = _ref4.handleScroll,
        maxHeight = _ref4.maxHeight,
        className = _ref4.className,
        stylesheet = _ref4.stylesheet;

    return React.createElement(
      PanelContainerPresenter,
      {
        innerRef: innerRef,
        maxHeight: maxHeight,
        className: className,
        stylesheet: stylesheet
      },
      React.createElement(
        PanelPresenter,
        {
          onScroll: handleScroll,
          className: className,
          stylesheet: stylesheet
        },
        content
      )
    );
  }
};
Flyout.__docgenInfo = {
  "description": "@typedef {Object} State\n@property {HTMLElement} [actionRef]\n@property {boolean} open Used to direct the flyout's transition behavior\n@property {HTMLElement} [panelRef]\n@property {SVGSVGElement} [pointerRef]\n@property {HTMLDivElement} [wrapperRef]",
  "displayName": "Flyout",
  "props": {
    "alterCoordinates": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Manipulate flyout coordinates before rendering"
    },
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": "Where the flyout will be anchored relative to target",
      "defaultValue": {
        "value": "DEFAULT_COORDINATES.anchorPoint",
        "computed": true
      }
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": "Target component to open the flyout. Can be either a node or a render function"
    },
    "content": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": "Content for the flyout. Can be either a node or a render function"
    },
    "defaultOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Default uncontrolled open state",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "fallbackAnchorPoints": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "enum",
          "computed": true,
          "value": "AVAILABLE_ANCHOR_POINTS"
        }
      },
      "required": false,
      "description": "When the flyout overflows the viewport, it'll attempt to\nuse the given anchor points in order to keep the flyout\nwithin the viewport.",
      "defaultValue": {
        "value": "AVAILABLE_ANCHOR_POINTS",
        "computed": true
      }
    },
    "panel": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Renders a custom flyout panel. Can be either a node or a render function",
      "defaultValue": {
        "value": "function(\n    {\n      innerRef,\n      content,\n      handleScroll,\n      maxHeight,\n      className,\n      stylesheet\n    }\n) {\n  return (\n    <PanelContainerPresenter\n      innerRef={innerRef}\n      maxHeight={maxHeight}\n      className={className}\n      stylesheet={stylesheet}\n    >\n      <PanelPresenter\n        onScroll={handleScroll}\n        className={className}\n        stylesheet={stylesheet}\n      >\n        {content}\n      </PanelPresenter>\n    </PanelContainerPresenter>\n  );\n}",
        "computed": false
      }
    },
    "pointer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "A custom pointer"
    },
    "maxHeight": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Max height of the flyout content, in pixels"
    },
    "onClickOutside": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout is open, and a click event occurs outside the flyout"
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout closes"
    },
    "onOpen": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout opens"
    },
    "onScroll": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function called when the flyout panel is scrolled"
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "When provided, it overrides the flyout's open state"
    },
    "openOnHover": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether flyout should open when the target is hovered over",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "openOnHoverDelay": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "If openOnHover is true, this prop will determine the delay\nfrom when mouseEnter begins until the flyout visually opens",
      "defaultValue": {
        "value": "500",
        "computed": false
      }
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to modify the component's styles"
    }
  }
};

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** @typedef {import("./getCoordinates").Coordinates} Coordinates */

var offsetProperties = {
  TOP: "top",
  LEFT: "left"
};

/**
 * Offsets the container
 * @param {string} offsetProperty
 * @param {Coordinates} coordinates
 * @param {number} diff
 * @returns {Coordinates}
 */
function offsetContainerProperty(offsetProperty, coordinates, diff) {
  return _extends$2({}, coordinates, {
    containerPosition: _extends$2({}, coordinates.containerPosition, _defineProperty({}, offsetProperty, coordinates.containerPosition[offsetProperty] + diff))
  });
}

/**
 * Vertically offsets the container
 * @param {Coordinates} coordinates
 * @param {number} diff
 * @returns {Coordinates}
 */
function offsetContainerVertical(coordinates, diff) {
  return offsetContainerProperty(offsetProperties.TOP, coordinates, diff);
}

/**
 * Horizontally offsets the container
 * @param {Coordinates} coordinates
 * @param {number} diff
 * @returns {Coordinates}
 */
function offsetContainerHorizontal(coordinates, diff) {
  return offsetContainerProperty(offsetProperties.LEFT, coordinates, diff);
}

/**
 * Horizontally offsets the panel while maintaining the equivalent pointer position
 * @param {Coordinates} coordinates
 * @param {number} diff
 * @returns {Coordinates}
 */
function offsetPanelHorizontal(coordinates, diff) {
  return _extends$2({}, coordinates, {
    pointerPosition: _extends$2({}, coordinates.pointerPosition, {
      left: coordinates.pointerPosition.left - diff
    }),
    containerPosition: _extends$2({}, coordinates.containerPosition, {
      left: coordinates.containerPosition.left + diff
    })
  });
}

/**
 * Moves the container away from the target relative the given the anchor point
 * @param {Coordinates} coordinates
 * @param {number} diff
 * @returns {Coordinates}
 */
function dislocateContainer(coordinates, diff) {
  var anchorPoint = coordinates.anchorPoint;


  switch (anchorPoint) {
    case anchorPoints.TOP_CENTER:
    case anchorPoints.TOP_LEFT:
    case anchorPoints.TOP_RIGHT:
      return offsetContainerVertical(coordinates, diff);
    case anchorPoints.BOTTOM_CENTER:
    case anchorPoints.BOTTOM_LEFT:
    case anchorPoints.BOTTOM_RIGHT:
      return offsetContainerVertical(coordinates, -1 * diff);
    case anchorPoints.LEFT_BOTTOM:
    case anchorPoints.LEFT_CENTER:
    case anchorPoints.LEFT_TOP:
      return offsetContainerHorizontal(coordinates, diff);
    case anchorPoints.RIGHT_BOTTOM:
    case anchorPoints.RIGHT_CENTER:
    case anchorPoints.RIGHT_TOP:
      return offsetContainerHorizontal(coordinates, -1 * diff);
    default:
      return coordinates;
  }
}

Flyout.Panel = PanelContainerPresenter;

export default Flyout;
export { PanelContainerPresenter as Panel, anchorPoints, AVAILABLE_ANCHOR_POINTS, AVAILABLE_ANCHOR_POINTS as availableAnchorPoints, dislocateContainer, offsetContainerHorizontal, offsetContainerVertical, offsetPanelHorizontal, PointerPresenter as Pointer, transitionStatuses, AVAILABLE_TRANSITION_STATUSES };
